export const FETCH_DISH_TYPE = {
  START: 'START_FETCH_DISH_TYPE',
  COMPLETE: 'COMPLETE_FETCH_DISH_TYPE',
  FAIL: 'FAIL_FETCH_DISH_TYPE',
  CLEANUP: 'CLEANUP_FETCH_DISH_TYPE',
}

export const UPDATE_DISH_TYPE_SIMPLE_DETAILS = {
  START: 'START_UPDATE_DISH_TYPE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_DETAILS',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_DETAILS',
}

export const UPDATE_DISH_TYPE_IGNORED_DETAILS = {
  START: 'START_UPDATE_DISH_TYPE_IGNORED_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_IGNORED_DETAILS',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_IGNORED_DETAILS',
}

export const UPDATE_DISH_TYPE_IMAGE_DETAILS = {
  START: 'START_UPDATE_DISH_TYPE_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_IMAGE_DETAILS',
}

export const UPDATE_DISH_TYPE_NOTES = {
  START: 'START_UPDATE_DISH_TYPE_NOTES',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_NOTES',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_NOTES',
}

export const UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS',
}

export const UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS',
}

export const SET_DISH_TYPE_PAGE_TO_DIRTY = 'SET_DISH_TYPE_PAGE_TO_DIRTY'
